var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWsB2BIconBlockOutDates(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 137.12,
    height: 137.12,
    viewBox: "0 0 137.12 137.12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.68,47.9H49.9v-5H39.68Zm-2.29,1a3.23,3.23,0,0,1,2.29-1v-5a8.24,8.24,0,0,0-5.83,2.41Zm-1,2.29a3.21,3.21,0,0,1,1-2.29l-3.54-3.54a8.27,8.27,0,0,0-2.41,5.83Zm0,109.14V51.14h-5V160.28Zm.25,1.24a3.09,3.09,0,0,1-.25-1.24h-5a8.14,8.14,0,0,0,.63,3.16Zm.7,1.06a3.16,3.16,0,0,1-.7-1.06l-4.62,1.92a8.17,8.17,0,0,0,1.78,2.67Zm1,.7a3.22,3.22,0,0,1-1-.7l-3.54,3.53a8.19,8.19,0,0,0,2.68,1.79Zm1.24.25a3.35,3.35,0,0,1-1.24-.25l-1.91,4.62a8.31,8.31,0,0,0,3.15.63Zm120.64,0H39.68v5H160.32Zm1.24-.25a3.35,3.35,0,0,1-1.24.25v5a8.31,8.31,0,0,0,3.15-.63Zm1.05-.7a3.22,3.22,0,0,1-1.05.7l1.91,4.62a8.19,8.19,0,0,0,2.68-1.79Zm.7-1.06a3.16,3.16,0,0,1-.7,1.06l3.54,3.53a8.17,8.17,0,0,0,1.78-2.67Zm.25-1.24a3.09,3.09,0,0,1-.25,1.24l4.62,1.92a8.14,8.14,0,0,0,.63-3.16Zm0-109.14V160.28h5V51.14Zm-.95-2.29a3.21,3.21,0,0,1,.95,2.29h5a8.27,8.27,0,0,0-2.41-5.83Zm-2.29-1a3.23,3.23,0,0,1,2.29,1l3.54-3.54a8.24,8.24,0,0,0-5.83-2.41Zm-9.63,0h9.63v-5h-9.63ZM49.9,47.9a2.5,2.5,0,0,0,0-5Zm-16,112.38h0ZM39.68,166v0Zm120.64,0v0Zm5.74-5.75h0ZM150.69,42.9a2.5,2.5,0,0,0,0,5Z",
    transform: "translate(-31.44 -31.41)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M75.33,47.9h49v-5h-49Zm49,0a2.5,2.5,0,0,0,0-5Zm-49-5a2.5,2.5,0,0,0,0,5Z",
    transform: "translate(-31.44 -31.41)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M60.16,33.91V53h5V33.91Zm0,19.13a2.5,2.5,0,0,0,5,0Zm5-19.13a2.5,2.5,0,0,0-5,0Z",
    transform: "translate(-31.44 -31.41)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M134.84,33.91V53h5V33.91Zm0,19.13a2.5,2.5,0,0,0,5,0Zm5-19.13a2.5,2.5,0,0,0-5,0Z",
    transform: "translate(-31.44 -31.41)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33.94,76.62H166.06v-5H33.94Zm132.12,0a2.5,2.5,0,0,0,0-5Zm-132.12-5a2.5,2.5,0,1,0,0,5Z",
    transform: "translate(-31.44 -31.41)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M75.92,100.44l44.62,44.62,3.54-3.54L79.46,96.91Zm44.62,44.62a2.5,2.5,0,1,0,3.54-3.54ZM79.46,96.91a2.5,2.5,0,0,0-3.54,3.53Z",
    transform: "translate(-31.44 -31.41)",
    fill: "red"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M120.54,96.91,75.92,141.52l3.54,3.54,44.62-44.62ZM75.92,141.52a2.5,2.5,0,1,0,3.54,3.54Zm48.16-41.08a2.5,2.5,0,0,0-3.54-3.53Z",
    transform: "translate(-31.44 -31.41)",
    fill: "red"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWsB2BIconBlockOutDates);
export default __webpack_public_path__ + "static/media/ws-b2b-icon-block-out-dates.74b2378dfac90734c364114758b6af13.svg";
export { ForwardRef as ReactComponent };